




















import LazyComponent from "v-lazy-component/vue2";
import { defineComponent, useRoute } from "@nuxtjs/composition-api";
import { useCart } from "~/modules/checkout/composables/useCart";
import { useMakeOrder, useUiState } from "~/composables";
import CheckoutHeader from "~/modules/checkout/components/checkoutComponent/CheckoutHeader.vue";

export default defineComponent({
  name: "CheckoutLayout",

  components: {
    LazyComponent,
    LoginModal: () =>
      import(
        /* webpackPrefetch: true */ "~/modules/customer/components/LoginModal/LoginModal.vue"
      ),
    Notification: () =>
      import(/* webpackPrefetch: true */ "~/components/Notification.vue"),
    AppFooter: () =>
      import(/* webpackPrefetch: true */ "~/components/AppFooter.vue"),
    CheckoutHeader,
  },

  setup() {
    const { loading } = useCart();
    const { loading: loadingOrder } = useMakeOrder();
    const { isLoginModalOpen, toggleLoginModal } = useUiState();
    const route = useRoute();

    return {
      loading,
      loadingOrder,
      toggleLoginModal,
      isLoginModalOpen,
      route,
    };
  },
  head: {
    htmlAttrs: {
      lang: "vi",
    },
    // link: [{ rel: "stylesheet", href: "/_nuxt/fonts.css" }],
  },
});
